<template>
  <div class="fill-height">
    <FufuHeader :shop="shop"> 予約の確認 </FufuHeader>
    <v-container class="white" fill-height>
      <v-layout column>
        <v-flex>
          <v-layout>
            <v-flex xs2>
              <v-btn
                :to="{
                  name: 'CustomerInput',
                  query: {
                    menuOption: $route.query.menuOption,
                    first: firstVisitor,
                    mode,
                  },
                }"
                text
                exact
                color="primary"
              >
                <v-icon>mdi-chevron-right</v-icon>
                前の画面へ戻る
              </v-btn>
            </v-flex>
            <v-flex xs8 class="text-center">
              内容を確認の上、予約するボタンを押してください。
            </v-flex>
          </v-layout>
        </v-flex>

        <v-alert
          v-for="e in errors.nonFieldErrors"
          :key="e"
          type="error"
          outlined
        >
          {{ e }}
        </v-alert>

        <v-flex>
          <v-card outlined>
            <v-layout>
              <v-flex
                xs4
                class="primary--text text-center pa-3"
                style="background-color: #f5f5f5"
              >
                <b> ご予約店舗 </b>
              </v-flex>
              <v-flex xs8 class="py-3 pl-5">
                {{ shop && shop.name }}
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex
                xs4
                class="primary--text text-center pa-3"
                style="background-color: #f5f5f5"
              >
                <b> メニュー </b>
              </v-flex>
              <v-flex xs8 class="py-3 pl-5">
                <v-layout column>
                  <span>{{ menuName }}</span>
                  <span v-if="colorName">
                    {{ colorName }}
                  </span>
                  <span v-if="menuOptionName">{{ menuOptionName }}</span>
                  <span v-if="scalpCareName">{{ scalpCareName }}</span>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex
                xs4
                class="primary--text text-center pa-3"
                style="background-color: #f5f5f5"
              >
                <b> ご予約日時 </b>
              </v-flex>
              <v-flex xs8 class="py-3 pl-5">
                {{ start | datetime }}
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex
                xs4
                class="primary--text text-center pa-3"
                style="background-color: #f5f5f5"
              >
                <b> お客さま情報 </b>
              </v-flex>
              <v-flex xs8 class="py-3 pl-5">
                <span v-if="customer">
                  {{ customer.membershipNumber }}
                  {{ customer.familyNameKana }}
                  {{ customer.givenNameKana }}
                  様
                </span>
                <span v-else>
                  {{ form.familyNameKana }}
                  {{ form.givenNameKana }}
                  様
                </span>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex>
          <v-card flat>
            <v-card-text class="text-center red--text">
              スムーズに皆さまをご案内させて頂くために
              <br />
              予約時間の5分前にお越し頂けますと幸いです。
              <br />
              <br />
              また、ご予約頂いた時間にお越し頂けなかった場合、予約のキャンセル、
              <br />
              もしくは他のお客様優先をさせていただく場合がございますのでご了承ください。
            </v-card-text>
          </v-card>
        </v-flex>

        <v-layout justify-center>
          <v-checkbox v-model="agree" color="primary">
            <span slot="label">確認しました</span>
          </v-checkbox>
        </v-layout>

        <v-layout>
          <v-flex xs4 offset-xs4>
            <v-btn
              :disabled="!agree"
              :loading="loading"
              color="primary"
              large
              block
              @click="submit"
            >
              <span slass="subtitle-1">
                <b> 予約する </b>
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment'
import FufuHeader from '@/components/FufuHeader'

export default {
  name: 'ConfirmView',
  components: {
    FufuHeader,
  },
  filters: {
    datetime(value) {
      if (!value) return value
      return moment(value).format('YYYY/MM/DD HH:mm')
    },
  },
  props: {
    shopId: {
      type: String,
      default: '',
    },
    menuId: {
      type: [String, Number],
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
    time: {
      type: String,
      default: '',
    },

    firstVisitor: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    agree: false,
    form: null,
    shop: null,
    start: null,
    customer: null,
    menuName: '',
    menuOptionName: '',
    colorName: '',
    errors: {},
    loading: false,

    reservedBy: 6,
  }),
  created() {
    this.fetchData()
    this.form = Object.assign(
      {
        reservedBy: this.mode === 2 ? 9 : 6,
      },
      this.$route.query
    )
    this.validate()
  },
  methods: {
    async fetchData() {
      this.shop = await this.$api.shops(this.shopId).get()
    },
    async validate() {
      try {
        this.errors = {}
        let {
          start,
          customer,
          menuName,
          colorName,
          menuOptionName,
          scalpCareName,
        } = await this.$api.reservations().validateInShop(this.form)
        this.start = start
        this.menuName = menuName
        this.menuOptionName = menuOptionName
        this.scalpCareName = scalpCareName
        this.colorName = colorName
        this.customer = customer
      } catch (err) {
        if (err.status === 400) {
          this.errors = err.response.data
        } else {
          console.error(err)
        }
      }
    },
    async submit() {
      if (this.loading) return
      try {
        this.loading = true
        this.errors = {}
        const result = await this.$api.reservations().createInShop(this.form)
        if (this.customer && !this.customer.birthday) {
          // NOTE: 誕生日が未設定の場合は誕生日入力画面に移動
          this.$router.replace({
            name: 'BirthdayInput',
            params: { customerId: this.customer.id },
            query: {
              shop: this.shopId,
              result: JSON.stringify(result),
            },
          })
        } else {
          this.$router.replace({
            name: 'Done',
            query: {
              shop: this.shopId,
              result: JSON.stringify(result),
            },
          })
        }
      } catch (err) {
        if (err.status === 400) {
          this.errors = err.response.data
        } else {
          console.error(err)
        }
      }
      this.loading = false
    },
  },
}
</script>

<style></style>
